define("calendar/components/calendar/bttp-promo", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service"], function (_exports, _component, _templateFactory, _component2, _object, _service) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/service",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @focusTrap={{true}} @closable={{true}} @close={{this.close}} as |modal|>
    <modal.card class="o--modalCard--narrow">
      <modal.card-body>
        <div class="u--row u--row--noCollapse">
          <div class="u--col__6 u--p__t u--p__r">
            <img class="o--media" src={{this.imagePath}}>
          </div>
          <div class="u--col__6">
            <modal.card-header class="u--p__t u--p__lr__0">
              <p class="o--modalHeader__title">
                {{t (concat "bttp.discoverability." this.socialProfileType ".title")}}
              </p>
            </modal.card-header>
            <modal.card-body class="u--p__t__0 u--p__lr__0">
              <p>
                {{html-safe (t (concat "bttp.discoverability." this.socialProfileType ".intro"))}}
                <Shared::Link
                  @href={{this.learnMoreLink}}
                  @text={{t "shared_phrases.learn_more_lower_case"}}
                />
              </p>
              <ul class="u--listUnstyle">
                <li class="u--m__b">
                  <span class="u--text--sm u--text--bold u--text--light">{{t (concat "bttp.discoverability." this.socialProfileType ".step_1")}}</span><br>
                  {{html-safe (t (concat "bttp.discoverability." this.socialProfileType ".step_1_description"))}}
                </li>
                <li class="u--m__b">
                  <span class="u--text--sm u--text--bold u--text--light">{{t (concat "bttp.discoverability." this.socialProfileType ".step_2")}}</span><br>
                  {{html-safe (t (concat "bttp.discoverability." this.socialProfileType ".step_2_description"))}}
                </li>
                <li>
                  <span class="u--text--sm u--text--bold u--text--light">{{t (concat "bttp.discoverability." this.socialProfileType ".step_3")}}</span><br>
                  {{t (concat "bttp.discoverability." this.socialProfileType ".step_3_description")}}
                </li>
              </ul>
            </modal.card-body>
          </div>
        </div>
      </modal.card-body>
      <modal.card-footer>
        <Shared::Ui::Button
          class="u--float--left"
          @onClick={{this.close}}
          @type="outline"
          @text={{t "shared_phrases.not_now"}}
        />
        <Shared::Ui::Button
          class="u--float--right"
          @onClick={{this.openCalendarSettings}}
          @type="primary"
          @text={{this.openCalendarSettingsText}}
        />
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  
  */
  {
    "id": "65pWauU+",
    "block": "[[[8,[39,0],null,[[\"@focusTrap\",\"@closable\",\"@close\"],[true,true,[30,0,[\"close\"]]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],[[24,0,\"o--modalCard--narrow\"]],null,[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"u--col__6 u--p__t u--p__r\"],[12],[1,\"\\n          \"],[10,\"img\"],[14,0,\"o--media\"],[15,\"src\",[30,0,[\"imagePath\"]]],[12],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"u--col__6\"],[12],[1,\"\\n          \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__t u--p__lr__0\"]],null,[[\"default\"],[[[[1,\"\\n            \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[[28,[37,2],[\"bttp.discoverability.\",[30,0,[\"socialProfileType\"]],\".title\"],null]],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"]],[]]]]],[1,\"\\n          \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__t__0 u--p__lr__0\"]],null,[[\"default\"],[[[[1,\"\\n            \"],[10,2],[12],[1,\"\\n              \"],[1,[28,[35,3],[[28,[37,1],[[28,[37,2],[\"bttp.discoverability.\",[30,0,[\"socialProfileType\"]],\".intro\"],null]],null]],null]],[1,\"\\n              \"],[8,[39,4],null,[[\"@href\",\"@text\"],[[30,0,[\"learnMoreLink\"]],[28,[37,1],[\"shared_phrases.learn_more_lower_case\"],null]]],null],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"ul\"],[14,0,\"u--listUnstyle\"],[12],[1,\"\\n              \"],[10,\"li\"],[14,0,\"u--m__b\"],[12],[1,\"\\n                \"],[10,1],[14,0,\"u--text--sm u--text--bold u--text--light\"],[12],[1,[28,[35,1],[[28,[37,2],[\"bttp.discoverability.\",[30,0,[\"socialProfileType\"]],\".step_1\"],null]],null]],[13],[10,\"br\"],[12],[13],[1,\"\\n                \"],[1,[28,[35,3],[[28,[37,1],[[28,[37,2],[\"bttp.discoverability.\",[30,0,[\"socialProfileType\"]],\".step_1_description\"],null]],null]],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,\"li\"],[14,0,\"u--m__b\"],[12],[1,\"\\n                \"],[10,1],[14,0,\"u--text--sm u--text--bold u--text--light\"],[12],[1,[28,[35,1],[[28,[37,2],[\"bttp.discoverability.\",[30,0,[\"socialProfileType\"]],\".step_2\"],null]],null]],[13],[10,\"br\"],[12],[13],[1,\"\\n                \"],[1,[28,[35,3],[[28,[37,1],[[28,[37,2],[\"bttp.discoverability.\",[30,0,[\"socialProfileType\"]],\".step_2_description\"],null]],null]],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,\"li\"],[12],[1,\"\\n                \"],[10,1],[14,0,\"u--text--sm u--text--bold u--text--light\"],[12],[1,[28,[35,1],[[28,[37,2],[\"bttp.discoverability.\",[30,0,[\"socialProfileType\"]],\".step_3\"],null]],null]],[13],[10,\"br\"],[12],[13],[1,\"\\n                \"],[1,[28,[35,1],[[28,[37,2],[\"bttp.discoverability.\",[30,0,[\"socialProfileType\"]],\".step_3_description\"],null]],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,5],[[24,0,\"u--float--left\"]],[[\"@onClick\",\"@type\",\"@text\"],[[30,0,[\"close\"]],\"outline\",[28,[37,1],[\"shared_phrases.not_now\"],null]]],null],[1,\"\\n      \"],[8,[39,5],[[24,0,\"u--float--right\"]],[[\"@onClick\",\"@type\",\"@text\"],[[30,0,[\"openCalendarSettings\"]],\"primary\",[30,0,[\"openCalendarSettingsText\"]]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]],[1,\"\\n\"]],[\"modal\"],false,[\"shared/modal\",\"t\",\"concat\",\"html-safe\",\"shared/link\",\"shared/ui/button\"]]",
    "moduleName": "calendar/components/calendar/bttp-promo.hbs",
    "isStrictMode": false
  });

  let BttpPromoComponent = (_class = class BttpPromoComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "bttp", _descriptor2, this);

      _initializerDefineProperty(this, "intl", _descriptor3, this);

      _initializerDefineProperty(this, "router", _descriptor4, this);

      _initializerDefineProperty(this, "segment", _descriptor5, this);

      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor6, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor7, this);

      this._setReceivedBttpDiscovery();
    }

    get socialProfile() {
      return this.selectedSocialProfiles.firstProfile;
    }

    get socialProfileType() {
      var _this$socialProfile;

      return (_this$socialProfile = this.socialProfile) === null || _this$socialProfile === void 0 ? void 0 : _this$socialProfile.profileType;
    }

    get imagePath() {
      return "/assets/images/img--bttp--promo__".concat(this.socialProfileType, ".png");
    }

    get learnMoreLink() {
      // TODO: update to allow different links for different social profiles once KB articles are available
      return 'https://help.later.com/hc/articles/360042771694';
    }

    get openCalendarSettingsText() {
      if (this.bttp.canBttp) {
        return this.intl.t('bttp.discoverability.enable_in_calendar');
      }

      return this.intl.t('bttp.discoverability.upgrade_in_calendar');
    }

    openCalendarSettings() {
      this.args.close();
      this.args.viewCalendarSettings();
      this.segment.track('bttp-opt-in', {
        social_profile_handle: this.socialProfile.nickname,
        active_trial: !!this.subscriptions.hasActiveTrial
      });
    }

    close() {
      this.args.close();
      this.segment.track('declined-bttp', {
        social_profile_handle: this.socialProfile.nickname,
        active_trial: !!this.subscriptions.hasActiveTrial
      });
    }

    _setReceivedBttpDiscovery() {
      this.socialProfile.set('receivedBttpDiscovery', true);
      this.socialProfile.save();
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bttp", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "openCalendarSettings", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openCalendarSettings"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype)), _class);
  _exports.default = BttpPromoComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BttpPromoComponent);
});